module.exports = __webpack_public_path__ + "img/loginimg.a2a540b2.svg";